export default __webpack_public_path__ + "static/media/boundary-bg.63987bc3.jpg";